import { DEFAULT_LANGUAGE, DEFAULT_TEMPLATE_ID, type TemplateId } from '@cibli/shared';
import { createContext, type ReactNode, useContext, useState } from 'react';

interface CVTemplateContextState {
  cvTemplateId: TemplateId;
  setCvTemplateId: (id: TemplateId) => void;
  cvTemplateParams: Record<string, unknown>;
  setCvTemplateParams: (params: Record<string, unknown>) => void;
  currentLocaleCv: string;
  setCurrentLocaleCv: (locale: string) => void;
}

const CVTemplateContext = createContext<CVTemplateContextState | undefined>(undefined);

interface CVTemplateProviderProps {
  children: ReactNode;
}

export function CVTemplateProvider({ children }: CVTemplateProviderProps) {
  const [cvTemplateId, setCvTemplateId] = useState<TemplateId>(DEFAULT_TEMPLATE_ID);
  const [cvTemplateParams, setCvTemplateParams] = useState<Record<string, unknown>>({});
  const [currentLocaleCv, setCurrentLocaleCv] = useState<string>(DEFAULT_LANGUAGE);

  const value: CVTemplateContextState = {
    cvTemplateId,
    setCvTemplateId,
    cvTemplateParams,
    setCvTemplateParams,
    currentLocaleCv,
    setCurrentLocaleCv,
  };

  return <CVTemplateContext.Provider value={value}>{children}</CVTemplateContext.Provider>;
}

// eslint-disable-next-line react-refresh/only-export-components
export function useCVTemplateContext(): CVTemplateContextState {
  const context = useContext(CVTemplateContext);
  if (context === undefined) {
    throw new Error('useCVTemplateContext must be used within a CVTemplateProvider');
  }
  return context;
}
